<template>

</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.detial_item {
  width: 100%;
  .header {
    height: 48px;
    background: #fcfbfa;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 23px;
    box-sizing: border-box;
    .name {
      font-weight: 400;
      font-size: 14px;
      color: #222222;
    }
  }

}
</style>
